<template>
  <transition name="fade">
    <div class="no-permission flex flex-column justify-center align-center">
      <img v-if="buy" src="@/assets/images/buy.png" height="267" />
      <img v-else src="@/assets/images/permission.png" height="267" />
      <div class="title">{{ title }}</div>
      <div class="content">{{ content }}</div>
      <div class="message">{{ message }}</div>
    </div>
  </transition>
</template>
<style lang="less" scoped>
@import './Index.less';
</style>
<script>
export default {
  data () {
    return {
      title: this.$route.query.title,
      content: this.$route.query.content,
      message: this.$route.query.msg,
      buy: false
    }
  },
  methods: {},
  watch: {
    $route (to, from) {
      this.title = to.query.title,
      this.content = to.query.content,
      this.message = to.query.msg
      this.buy = to.query.buy
    }
  }
}
</script>
